import MyCanvas from "./MyCanvas";
export default MyCanvas;
